import { ITopology } from '../app/apiSlice';
import { useGetConfigQuery } from '../app/apiSlice';

export enum ExportExtension {
  JSON = 'json',
  YAML = 'yaml'
}

const useHandleExport = () => {

  const { data: config } = useGetConfigQuery();

  const handleExport = (topology: ITopology) => {
    //When you export a graph, the runtime must be in the back type (whitout id)
    const newTopoWithruntimes = {...topology, environnement:"BAS", treatmentVersion: config ? config.treatmentVersion : ""}
    exportFile(newTopoWithruntimes, topology.name, ExportExtension.JSON)
  }

  const exportFile = (objToExport: ITopology | string, name: string, extension: ExportExtension ) => {
    const data: string = typeof objToExport !== 'string' ? JSON.stringify(objToExport) : objToExport;
    const blob = new Blob([data], { type: "application/json" });
    const href = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = href;
    link.download = `${name}.${extension.toString()}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return {
    handleExport, exportFile
  };
};

export default useHandleExport;
